import SeoHead from '@/components/base/SeoHead';
import FeatureSection from './components/FeatureSection';
import DownloadSection from './components/DownloadSection';
import TutorialSection from './components/TutorialSection';
import FAQSection from './components/FAQSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '91浏览器',
  url: 'https://mingcidianzi162.cn',
  description: '91浏览器是新一代极速安全浏览器，提供极速浏览引擎、五重隐私保护、多端数据同步、智能广告拦截等核心功能，支持Windows、macOS、Android、iOS全平台免费下载。',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-9191',
    contactType: 'customer service',
    email: 'support@91browser.com',
    availableLanguage: 'Chinese',
  },
  address: {
    '@type': 'PostalAddress',
    addressLocality: '北京',
    addressRegion: '北京',
    addressCountry: 'CN',
    streetAddress: '海淀区中关村科技园',
  },
};

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '91浏览器',
  url: 'https://mingcidianzi162.cn',
  description: '91浏览器官方网站 - 极速浏览·隐私保护·多端同步',
  inLanguage: 'zh-CN',
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '91浏览器官网 - 极速浏览·隐私保护·多端同步',
  description: '91浏览器网页是您快速访问91浏览器在线功能的核心入口，提供网页版登录、功能介绍、下载指引及使用教程。无需安装客户端，直接通过91浏览器网页享受极速浏览、隐私保护与多端同步体验。',
  url: 'https://mingcidianzi162.cn',
  inLanguage: 'zh-CN',
  isPartOf: {
    '@type': 'WebSite',
    name: '91浏览器',
    url: 'https://mingcidianzi162.cn',
  },
};

export default function Home() {
  return (
    <>
      <SeoHead
        title="91浏览器官网 - 极速浏览·隐私保护·多端同步 | 官方入口"
        description="91浏览器网页是您快速访问91浏览器在线功能的核心入口，提供网页版登录、功能介绍、下载指引及使用教程。无需安装客户端，直接通过91浏览器网页享受极速浏览、隐私保护与多端同步体验，立即访问官方页面了解更多。"
        keywords="91浏览器网页,91浏览器网页版入口,91浏览器在线使用,91浏览器官网下载,91浏览器功能介绍,91浏览器隐私保护,91浏览器多端同步"
        canonicalUrl="/"
        ogImage="https://readdy.ai/api/search-image?query=Modern%20browser%20product%20hero%20image%20with%20speed%20and%20security%20concept%2C%20warm%20orange%20and%20gold%20gradient%2C%20clean%20minimalist%20design%2C%20professional%20tech%20aesthetic&width=1200&height=630&seq=og-home&orientation=landscape"
      />
      <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webSiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>

      <main>
        <section className="relative h-[520px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20geometric%20landscape%20with%20warm%20orange%20coral%20and%20gold%20gradients%2C%20minimalist%20digital%20art%2C%20soft%20ambient%20glow%2C%20technology%20atmosphere%2C%20clean%20aesthetic%2C%20modern%20tech%20feel%2C%20smooth%20curves%2C%20warm%20lighting%20with%20subtle%20depth&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
              alt="91浏览器 - 极速安全浏览体验"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
          </div>

          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <div className="max-w-[800px] mx-auto">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
                <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
                <span className="text-sm text-white/90">v3.8.1 全新发布 · 性能提升40%</span>
              </div>

              <h1 className="text-3xl md:text-5xl font-bold text-white mb-5 leading-tight">
                极速浏览，<span className="text-primary-400">安全无忧</span>
              </h1>
              <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
                91浏览器搭载自研闪电渲染引擎，网页加载速度提升300%，
                配合五重隐私保护体系，为您提供更快、更安全的上网体验。
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="#"
                  className="px-8 py-3.5 rounded-full bg-white text-primary-600 text-sm font-semibold hover:bg-white/95 transition-all whitespace-nowrap cursor-pointer shadow-lg shadow-white/20"
                >
                  <i className="ri-download-2-line mr-2 text-base"></i>
                  免费下载
                </a>
                <a
                  href="#features"
                  className="px-8 py-3.5 rounded-full bg-white/10 backdrop-blur-sm text-white text-sm font-medium hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer border border-white/20"
                >
                  了解更多
                  <i className="ri-arrow-down-line ml-2"></i>
                </a>
              </div>

              <div className="flex flex-wrap items-center justify-center gap-6 mt-10 text-white/60 text-xs">
                <span className="flex items-center gap-1.5">
                  <i className="ri-checkbox-circle-line text-green-400 text-base"></i>
                  2亿+用户信赖
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-checkbox-circle-line text-green-400 text-base"></i>
                  4.9分好评
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-checkbox-circle-line text-green-400 text-base"></i>
                  安全认证
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-checkbox-circle-line text-green-400 text-base"></i>
                  永久免费
                </span>
              </div>
            </div>
          </div>
        </section>

        <div id="features">
          <FeatureSection />
        </div>
        <DownloadSection />
        <TutorialSection />
        <FAQSection />
      </main>
    </>
  );
}